import { c as _c } from "react/compiler-runtime";
import Tooltip from '@/components/modules/Tooltip';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { Button } from '@winelidays/wld-tsx-2/elements';
import { capitalize } from '@winelidays/wld-tsx-2/utils';
import SegmentationTable from './SegmentationTable';
const Segmentation = (t0) => {
    const $ = _c(17);
    const { segmentation, tariffName } = t0;
    const translate = useTranslate();
    let t1;
    if ($[0] !== tariffName || $[1] !== translate) {
        t1 = capitalize(translate("practical.prices.tariff.title", { tariffName }));
        $[0] = tariffName;
        $[1] = translate;
        $[2] = t1;
    }
    else {
        t1 = $[2];
    }
    const title = t1;
    let t2;
    if ($[3] !== translate) {
        t2 = translate("messages.more_info");
        $[3] = translate;
        $[4] = t2;
    }
    else {
        t2 = $[4];
    }
    const moreInfoButton = t2;
    let t3;
    if ($[5] !== title) {
        t3 = <p className="font-semibold text-base">{title}</p>;
        $[5] = title;
        $[6] = t3;
    }
    else {
        t3 = $[6];
    }
    let t4;
    if ($[7] !== segmentation) {
        t4 = <SegmentationTable segmentation={segmentation}/>;
        $[7] = segmentation;
        $[8] = t4;
    }
    else {
        t4 = $[8];
    }
    let t5;
    if ($[9] !== t3 || $[10] !== t4) {
        t5 = <>{t3}{t4}</>;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    }
    else {
        t5 = $[11];
    }
    let t6;
    if ($[12] !== moreInfoButton) {
        t6 = <Button title={moreInfoButton} className="btn-ghost-primary align-baseline text-xs -ml-2">
      {moreInfoButton}
    </Button>;
        $[12] = moreInfoButton;
        $[13] = t6;
    }
    else {
        t6 = $[13];
    }
    let t7;
    if ($[14] !== t5 || $[15] !== t6) {
        t7 = <Tooltip content={t5}>{t6}
    </Tooltip>;
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
    }
    else {
        t7 = $[16];
    }
    return t7;
};
export default Segmentation;
